module.exports = __webpack_public_path__ + "img/1588723237.34065b17.jpg";